/**
 * PWA Install Handler
 * Manages the installation prompt for Progressive Web App on mobile devices
 */

(function() {
    'use strict';

    let deferredPrompt = null;
    let isIOS = false;
    let isAndroid = false;
    let isStandalone = false;

    /**
     * Detect the user's platform
     */
    function detectPlatform() {
        const userAgent = window.navigator.userAgent.toLowerCase();
        isIOS = /iphone|ipad|ipod/.test(userAgent);
        isAndroid = /android/.test(userAgent);

        // Check if app is already installed (running in standalone mode)
        isStandalone = window.matchMedia('(display-mode: standalone)').matches
            || window.navigator.standalone
            || document.referrer.includes('android-app://');

        return { isIOS, isAndroid, isStandalone };
    }

    /**
     * Check if the install button should be shown
     */
    function shouldShowInstallButton() {
        // Don't show if already installed
        if (isStandalone) {
            return false;
        }

        // Show for iOS devices (manual instructions)
        if (isIOS) {
            return true;
        }

        // Show for Android if we have the prompt
        if (isAndroid && deferredPrompt) {
            return true;
        }

        // Show for desktop if we have the prompt
        if (deferredPrompt) {
            return true;
        }

        return false;
    }

    /**
     * Show the install modal
     */
    function showInstallModal() {
        const modal = new bootstrap.Modal(document.getElementById('pwaInstallModal'));
        const androidSection = document.getElementById('pwaInstallAndroid');
        const iosSection = document.getElementById('pwaInstallIOS');
        const notSupportedSection = document.getElementById('pwaInstallNotSupported');
        const installButton = document.getElementById('pwaInstallButton');

        // Hide all sections first
        androidSection.classList.add('d-none');
        iosSection.classList.add('d-none');
        notSupportedSection.classList.add('d-none');
        installButton.classList.add('d-none');

        if (isIOS) {
            // Show iOS instructions
            iosSection.classList.remove('d-none');
        } else if (deferredPrompt) {
            // Show Android/Chrome install
            androidSection.classList.remove('d-none');
            installButton.classList.remove('d-none');
        } else {
            // Not supported
            notSupportedSection.classList.remove('d-none');
        }

        modal.show();
    }

    /**
     * Handle the install button click
     */
    function handleInstallClick() {
        if (!deferredPrompt) {
            return;
        }

        // Show the install prompt
        deferredPrompt.prompt();

        // Wait for the user to respond to the prompt
        deferredPrompt.userChoice.then((choiceResult) => {
            if (choiceResult.outcome === 'accepted') {
                console.log('User accepted the install prompt');
                // Hide the install button
                const triggerButton = document.getElementById('pwaInstallTrigger');
                if (triggerButton) {
                    triggerButton.classList.add('pwa-hidden');
                }
            } else {
                console.log('User dismissed the install prompt');
            }

            // Clear the deferred prompt
            deferredPrompt = null;

            // Close the modal
            const modal = bootstrap.Modal.getInstance(document.getElementById('pwaInstallModal'));
            if (modal) {
                modal.hide();
            }
        });
    }

    /**
     * Update the install button visibility
     */
    function updateInstallButtonVisibility() {
        const triggerButton = document.getElementById('pwaInstallTrigger');

        if (!triggerButton) {
            return;
        }

        if (shouldShowInstallButton()) {
            triggerButton.classList.remove('pwa-hidden');
        } else {
            triggerButton.classList.add('pwa-hidden');
        }
    }

    /**
     * Initialize the PWA install handler
     */
    function init() {
        detectPlatform();

        // Listen for the beforeinstallprompt event
        window.addEventListener('beforeinstallprompt', (e) => {
            // Prevent the mini-infobar from appearing on mobile
            e.preventDefault();

            // Stash the event so it can be triggered later
            deferredPrompt = e;

            // Update button visibility
            updateInstallButtonVisibility();
        });

        // Listen for app installed event
        window.addEventListener('appinstalled', () => {
            console.log('PWA was installed');

            // Hide the install button
            const triggerButton = document.getElementById('pwaInstallTrigger');
            if (triggerButton) {
                triggerButton.classList.add('pwa-hidden');
            }

            // Clear the deferred prompt
            deferredPrompt = null;
        });

        // Set up event listeners when DOM is ready
        document.addEventListener('DOMContentLoaded', () => {
            // Install trigger button
            const triggerButton = document.getElementById('pwaInstallTrigger');
            if (triggerButton) {
                triggerButton.addEventListener('click', showInstallModal);
            }

            // Install button in modal
            const installButton = document.getElementById('pwaInstallButton');
            if (installButton) {
                installButton.addEventListener('click', handleInstallClick);
            }

            // Update button visibility on page load
            updateInstallButtonVisibility();
        });
    }

    // Initialize on script load
    init();

})();